import '@splidejs/splide/css';
import Splide from '@splidejs/splide';
import filtersLayout from '@js/vue/logic/filtersLayout';

// Splide arrow SVG path (chevron right)
const SPLIDE_ARROW_PATH =
    'M30.1708 18.6167C30.1795 18.6248 30.1881 18.633 30.1967 18.6411C31.2678 19.6677 31.2678 21.3323 30.1967 22.3589L14.6824 37.23C13.6114 38.2567 11.8748 38.2567 10.8038 37.23C9.73277 36.2034 9.73277 34.5389 10.8038 33.5123L24.3785 20.5003L10.8033 7.48767C9.73224 6.4611 9.73224 4.79676 10.8033 3.76993C11.8743 2.74336 13.6108 2.74336 14.6819 3.76993L30.1708 18.6167Z';

// Services page — category carousel powered by Splide.js.
// Scrolls to the active pill on mount, shows/hides arrows automatically.
function initServicesCategorySplide() {
    const el = document.getElementById('services-category-splide');
    if (!el) return;

    const activeIndex = parseInt(el.dataset.activeIndex || '0', 10);

    const splide = new Splide(el, {
        type: 'slide',
        autoWidth: true,
        gap: '1rem',
        pagination: false,
        arrows: true,
        drag: true,
        dragMinThreshold: { mouse: 10, touch: 40 },
        arrowPath: SPLIDE_ARROW_PATH,
        classes: { arrows: 'splide-custom-arrow' },
    });

    splide.on('mounted', () => {
        if (!Number.isFinite(activeIndex) || activeIndex <= 0) return;
        window.requestAnimationFrame(() => {
            try {
                const controller = splide.Components?.Controller;
                if (!controller) return;
                const endIndex = controller.getEnd();
                const targetIndex = Math.min(activeIndex, endIndex);
                if (targetIndex > 0) splide.go(targetIndex);
            } catch (err) {
                console.warn('services-category-splide: failed to scroll to active slide', err);
            }
        });
    });

    splide.mount();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initServicesCategorySplide);
} else {
    initServicesCategorySplide();
}

// Wire category-slider pill clicks into the same filter mechanism as the modal-card.
// Pills are <button>s with data-slug; the Vue component exposes selectCategoryBySlug
// via window.test (set in mounted()), which sets filters.category and runs
// applyServiceFilters — the same code path the modal's "Apply Filters" button uses.
(function () {
    const splideEl = document.getElementById('services-category-splide');
    if (!splideEl) return;

    splideEl.addEventListener('click', function (event) {
        const pill = event.target.closest('.services-category-splide__pill');
        if (!pill) return;
        event.preventDefault();
        const slug = pill.dataset.slug;
        if (window.test && typeof window.test.selectCategoryBySlug === 'function') {
            window.test.selectCategoryBySlug(slug);
        }
    });
})();

(function () {
    const displayListView = document.getElementById('display-list-view');
    if (displayListView) {
        const layout = filtersLayout();
        layout.initializeLayout();
        displayListView.addEventListener('click', function (event) {
            event.preventDefault();
            layout.displayListView();
        });
    }
})();

(function () {
    const displayMapView = document.getElementById('display-map-view');
    if (displayMapView) {
        const layout = filtersLayout();
        layout.initializeLayout();
        displayMapView.addEventListener('click', function (event) {
            event.preventDefault();
            layout.displayMapView();
        });
    }
})();

(function () {
    const sortSelect = document.getElementsByName('sort-by-price-value');
    if (sortSelect) {
        sortSelect.forEach((oneSortSelect) => {
            oneSortSelect.addEventListener('change', () => {
                dataLayer.push({
                    event: 'sortingApplied',
                    sortingType: oneSortSelect.value,
                });
                window.test.applyServiceFilters(false, oneSortSelect.value, true);
            });
        });
    }
})();

(function () {
    //First element in the select list
    const selectElement = document.querySelector('select[name="sort-by-price-value"]');

    if (selectElement) {
        // Add event listener for change event
        selectElement.addEventListener('change', function () {
            // Check if the reset option was clicked
            if (selectElement.value === '') {
                // Reset filters
                if (window.test && typeof window.test.applyServiceFilters === 'function') {
                    window.test.applyServiceFilters(false, null, true);
                }
                //Reset dropdown selection
                selectElement.selectedIndex = 0;
            }
        });
    }
})();
